export class FileHolder {
  public pending = false;
  public serverResponse: Object;

  constructor(public src: string, public file: File) {
  }
}
